import { Component, computed, inject, input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  fixedUrl = input.required<string>();
  height = input.required<number>();
  params = input.required<{}>();
  sanitizer = inject(DomSanitizer);

  isLoadding = false;

  dashboardUrl = computed(()=>{
    const url = `${this.fixedUrl()}?params=${JSON.stringify(this.params())}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  })

  onLoadding(){
    this.isLoadding = true;
  }

}
